import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faStar } from '@fortawesome/pro-solid-svg-icons';

const ScoreScreen = ({ 
    score = 0, 
    totalQuestions = 0, 
    onPlayAgain = () => {}, 
    onExit = () => {},
    showPlayAgain = true 
}) => {
    const percentage = totalQuestions > 0 ? Math.round((score / totalQuestions) * 100) : 0;
    
    return (
        <div className="flex flex-col items-center justify-center p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
            <div className="text-center mb-6">
                <FontAwesomeIcon 
                    icon={faTrophy} 
                    className="text-6xl text-yellow-500 mb-4" 
                />
                <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">
                    Game Complete!
                </h2>
                <div className="text-4xl font-bold text-blue-500 mb-2">
                    {score}/{totalQuestions}
                </div>
                <div className="text-lg text-gray-600 dark:text-gray-400">
                    {percentage}% Correct
                </div>
            </div>
            
            <div className="flex gap-4">
                {showPlayAgain && (
                    <button
                        onClick={onPlayAgain}
                        className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                    >
                        Play Again
                    </button>
                )}
                <button
                    onClick={onExit}
                    className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
                >
                    Exit
                </button>
            </div>
        </div>
    );
};

export default ScoreScreen;
